import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useResolveOrderidFromVoNumber = (voNumber: string | null) => {
  const normalizedVoNumber = voNumber?.trim() || null;

  const query = useQuery({
    queryKey: ["orderid-by-vo", normalizedVoNumber],
    enabled: Boolean(normalizedVoNumber),
    queryFn: async (): Promise<number | null> => {
      if (!normalizedVoNumber) return null;

      const { data, error } = await supabase
        .from("orders_live_ls")
        .select("orderid")
        .eq("ordernumber", normalizedVoNumber)
        .limit(1)
        .maybeSingle();

      if (error) throw error;

      return data?.orderid != null ? Number(data.orderid) : null;
    },
  });

  return {
    orderid: query.data ?? null,
    isLoading: query.isLoading,
  };
};